import { Component, inject, DestroyRef, OnInit, ViewChild, AfterViewInit, NgModule, ChangeDetectionStrategy } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute, Router, NavigationEnd, RouterModule, RouterLink  } from '@angular/router';

import { FormArray, FormGroup, FormControl, FormBuilder, AbstractControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MatTable, MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatDialog, MatDialogActions, MatDialogClose, MatDialogContent, MatDialogRef, MatDialogTitle, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';

import { Observable, catchError, Subscription, throwError, firstValueFrom, EmptyError, repeat, map, mergeMap, forkJoin, of, switchMap ,first, delay, take, EMPTY} from 'rxjs';
import { filter, tap } from 'rxjs/operators';

import { FseService, FactureSearcher, FacturePreteLot, StateHelper } from '../fse.service';
import { SpinnerService } from '@app/shared/spinner.service';
import { AlertService } from '@app/shared/alert.service';
import { LoginService } from '@app/common/login.service';
import { ValuesService } from '@app/common/values/values.service';

import * as fselib from 'mercalink-fselib';
import { tofseformat, SupprimerHTTPResponse } from 'mercalink-fselib';

import { MenuCommonComponent } from '@app/shared/menu-common/menu-common.component';
import { DetailComponent } from '@app/fse/detail/detail.component'
import { DetailLotComponent } from '@app/fse/detail-lot/detail-lot.component';
import { DetailRspComponent } from '@app/fse/detail-rsp/detail-rsp.component';
import { FormatFSECurrencyPipe } from '@app/shared/pipes/format-currency.pipe';
import * as util from "@app/shared/util";
import * as constants from "@app/shared/constants";
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-recon',
  imports: [DetailRspComponent, ReactiveFormsModule, FormsModule, RouterModule, MenuCommonComponent, MatButtonModule, MatTableModule, MatIconModule, CommonModule, MatSelectModule, MatFormFieldModule, MatInputModule, FormatFSECurrencyPipe],
  templateUrl: './recon.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['../fse-common.scss', './recon.component.scss']
})
export class ReconComponent implements OnInit {
  // 1. TEMPLATE Dependencies (using inject is the modern standard)
  private fseService = inject(FseService);
  private router = inject(Router);
  private destroyRef = inject(DestroyRef); // To handle unsubscription
  public stateHelper = inject(StateHelper);

  public fselib = fselib;
	public util = util;  
  public rsps:fselib.FseRsp[] = [];
  public selectedRsp: fselib.FseRsp | null = null;
  
	private routerevents$: any;

	ngOnInit(): void {
    this.loadRsps(); // Initial Load: Run immediately on component init

    // TEMPLATE Modern way to subscribe with automatic cleanup
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd),
      takeUntilDestroyed(this.destroyRef)
    ).subscribe(() => this.loadRsps());
	} 

  public loadRsps() {
    this.fseService.getRsps$().pipe(
      tap((rsps:fselib.FseRsp[]) =>{
        rsps.forEach((rsp:fselib.FseRsp) => {
          const etat = this.stateHelper.getEtatRsp(rsp.data, true).label;
          rsp.etat = (etat === 'PAYÉE' ? etat : '');                        // Print only PAYÉE
        })
      }),
      takeUntilDestroyed(this.destroyRef)
    ).subscribe(data => this.rsps = data);
  }

  public toggleRsp(rsp: fselib.FseRsp): void {
    if (this.selectedRsp === rsp) {
      this.closePanel();
    } else {
      this.selectedRsp = rsp;
      document.body.style.overflow = 'hidden';
    }
  }

  public closePanel(): void {
    this.selectedRsp = null;
    document.body.style.overflow = 'auto';
  }
}